module.exports = __webpack_public_path__ + "img/export_block1.76ccbc99.png";